import * as React from 'react';

function SvgCustomerSupport(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19.108 21.5" {...props}>
      <path data-name="Path 301" d="M9.385 19.885V21.5a7.089 7.089 0 004.542-1.615z" fill="currentColor" />
      <path
        data-name="Path 302"
        d="M1.308 11.808v1.615a2.347 2.347 0 001.615 2.423s1.615 4.846 6.462 4.846"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
      />
      <path
        data-name="Path 303"
        d="M18.269 12.615h-2.423c0-5.04-2.423-7.269-2.423-7.269C11 11 2.923 6.962 2.923 12.615H.5v-3.23A8.938 8.938 0 019.385.5c3.231 0 4.038 1.615 4.038 1.615 3.231 0 4.846 4.038 4.846 7.269z"
        fill="none"
        stroke="currentColor"
      />
      <path
        data-name="Path 304"
        d="M10.935 15.846h-.808a1.212 1.212 0 100 2.423h.808a1.212 1.212 0 100-2.423z"
        fill="currentColor"
      />
      <path
        data-name="Path 305"
        d="M11.339 17.462h4.038a3.231 3.231 0 003.231-3.231v-2.423"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
}

export default SvgCustomerSupport;
